<template>
  <div>
    <b-row>
      <b-col cols="12">
        <sales-filter :get-report-data="getData" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="12"
              md="7"
            >
              <b-row>
                <b-col cols="12">
                  <default-card
                    title="Genel Toplam"
                    :value="sales.grandTotals.sales"
                    icon="CheckCircleIcon"
                    color="success"
                  />
                </b-col>
                <b-col
                  v-for="item in sales.data"
                  :key="item.id"
                  cols="12"
                  md="6"
                >
                  <default-card
                    :title="item.title"
                    :value="item.sales"
                    icon="CheckCircleIcon"
                    color="primary"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              cols="12"
              md="5"
            >
              <pie-charts
                v-if="sales.grandTotals.chartData.series.length"
                :series-data="sales.grandTotals.chartData.series"
                :categories-data="sales.grandTotals.chartData.labels"
                chart-title="Marka Bazlı Satış Oranları"
                chart-type="donut"
              />
            </b-col>
          </b-row>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import SalesFilter from '@/views/Sales/FilterCards/SalesFilter.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'SaleCounts',
  components: {
    LoadingCard,
    DefaultCard,
    SalesFilter,
    PieCharts,
    BRow,
    BCol,
  },
  computed: {
    loading() {
      return this.$store.getters['saleReports/loading']
    },
    sales() {
      return this.$store.getters['saleReports/sales']
    },
    salesParams() {
      return this.$store.getters['saleReports/salesParams']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('saleReports/getSales', this.salesParams)
    },
  },
}
</script>
